import React, {Component} from 'react';
import Lottie from 'react-lottie';

import PropTypes from "prop-types";

const propTypes = {
    children: PropTypes.element,
};

class Animation extends Component {

    render() {

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: this.props.animationData,
        };

        return (
            <div style={{
                background: 'white',
                marginTop: 60
            }}>
                <Lottie options={defaultOptions}
                        height={this.props.height}
                        width={this.props.width}
                />
                <div>
                    {this.props.children}
                </div>

            </div>
        );
    }
}

Animation.propTypes = propTypes;
export default Animation;